import {SingletonService} from '@/common/dependency.configs'
import {inject, injectable} from 'inversify'
import HttpHandler from '@/common/services/connect/HttpHandler'
import type RestResponse from '@/common/data/RestResponse'

@SingletonService
@injectable()
export class LoanRequestedAmountFactory {
  constructor(
    @inject(HttpHandler)
    private httpHandler: HttpHandler
  ) {}
  get(
    workspaceUUID: string,
    enrollmentId: number,
    accountId: number
  ): Promise<RestResponse<AccountLoanRequestedAmount>> {
    return this.httpHandler.get(
      `{{boltsbranch}}/workspace/${workspaceUUID}/enrollment/${enrollmentId}/account/${accountId}/loan-amount`
    )
  }

  post(
    workspaceUUID: string,
    enrollmentId: number,
    accountId: number,
    dto: AccountLoanRequestedAmount
  ): Promise<RestResponse<AccountLoanRequestedAmount>> {
    return this.httpHandler.post(
      `{{boltsbranch}}/workspace/${workspaceUUID}/enrollment/${enrollmentId}/account/${accountId}/loan-amount`,
      dto
    )
  }

  put(
    workspaceUUID: string,
    enrollmentId: number,
    accountId: number,
    dto: AccountLoanRequestedAmount
  ): Promise<RestResponse<AccountLoanRequestedAmount>> {
    return this.httpHandler.put(
      `{{boltsbranch}}/workspace/${workspaceUUID}/enrollment/${enrollmentId}/account/${accountId}/loan-amount/${dto.loanRequestUuid}`,
      dto
    )
  }

  save(
    workspaceUUID: string,
    enrollmentId: number,
    accountId: number,
    dto: AccountLoanRequestedAmount
  ): Promise<RestResponse<AccountLoanRequestedAmount>> {
    return dto.loanRequestUuid
      ? this.put(workspaceUUID, enrollmentId, accountId, dto)
      : this.post(workspaceUUID, enrollmentId, accountId, dto)
  }

  delete(
    workspaceUUID: string,
    enrollmentId: number,
    accountId: number,
    dto: AccountLoanRequestedAmount
  ): Promise<RestResponse<void>> {
    return this.httpHandler.delete(
      `{{boltsbranch}}/workspace/${workspaceUUID}/enrollment/${enrollmentId}/account/${accountId}/loan-amount/${dto.loanRequestUuid}`
    )
  }
}

export interface AccountLoanRequestedAmount {
  loanRequestUuid?: string
  accountId: number
  amount?: number
}
